export default [
  {
    path: '/user',
    name: 'user',
    component: r => require(['views/layout/Main'], r),
    redirect: '/user/list',
    children: [
      {
        path: 'list',
        name: 'user-list',
        component: r => require(['views/user/Main'], r)
      },
      {
        path: 'form',
        name: 'user-form',
        component: r => require(['views/user/children/Form'], r)
      }
    ]
  }
]
